import type { DriverRankingPeriodFilterEntity } from '../../domain/entities/DriverRankingPeriodFilterEntity'

export class DriverRankingPeriodFilterModel {
  regionId?: number
  startDate?: string
  endDate?: string
  status?: string
  page?: number
  limit?: number

  constructor(data: DriverRankingPeriodFilterEntity) {
    this.regionId = data.regionId
    this.startDate = data.startDate
    this.endDate = data.endDate
    this.status = data.status
    this.page = data.page !== undefined ? data.page + 1 : undefined
    this.limit = data.limit
  }
}
